import dataProvider from '../supabase/dataProvider'
import { isUUID, safeUUID } from '../common/isUUID'
import { supabaseClient } from '../supabase'

export const addNewLeadComment = async (leadId, userProfile, eventId = null, comment, addToList = false) => {
  if ( !comment ) {
    console.error('Null or empty comment')
    return
  }

  if (
    ! leadId ||
    ! isUUID (leadId)
  ) {
    console.error('Error with leadId : empty or not UUID for comment', comment)
    return
  }

  if (
    ! userProfile ||
    ! isUUID(userProfile.id)
  ) {
    console.error('Error with userProfile : empty or not UUID for comment', comment)
    return
  }

  const response = await dataProvider.create('lead_comments', {
    data: {
      lead_id: leadId,
      profile_id: userProfile.id,
      comment: comment,
      event_id: safeUUID(eventId),
    }
  })

  if ( !response || !response.data ) {
    console.error('Failed to create lead comment:', response)
    return
  }

  if ( addToList ) {
    const { error } = await supabaseClient
      .from('leads')
      .update({
        comment: {
          comment: comment,
          full_name: userProfile.full_name,
          created_at: new Date()
        }
      })
      .eq('id', leadId)

      if ( error ) {
        console.error('Failed to create lead list comment:', error)
      }
  }
}